var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useTheme } from '@emotion/react';
import { createColorSets } from './type';
var initProps = {
    shape: 'square',
    size: 'medium',
    loading: false,
    disabled: false
};
export function useButton(props) {
    var _a, _b;
    var theme = useTheme();
    var color = (_a = props.color) !== null && _a !== void 0 ? _a : 'primary';
    var variant = (_b = props.variant) !== null && _b !== void 0 ? _b : 'default';
    var colorSets = createColorSets(variant, theme, color);
    return __assign(__assign(__assign({}, initProps), props), { normal: colorSets.normal, hover: colorSets.hover, active: colorSets.active });
}
//# sourceMappingURL=useButton.js.map